import Link               from "next/link";
import { useTranslation } from "react-i18next";

import { useGetDeviceType }               from "_common/hooks/global";
import { shortenNumber }                  from "_common/utils";
import { PrimaryButton, SecondaryButton } from "_components/atoms/button";
import Icon                               from "_components/atoms/icon";
import Image                              from "_components/atoms/image";
import Typography                         from "_components/atoms/typography";
import FollowUser                         from "_components/molecules/followUser";
import SharePopper                        from "_components/molecules/sharePopper";
import useStyles                          from "_styles/molecules/broadcasterHeader";

import Description from "./description";

const component = props => {
	const {
		description,
		followProfile,
		getSrc,
		handleClickAway,
		handleClickOpen,
		id,
		isBlockedByStreamer,
		isCeleb,
		name,
		noOfFollowers,
		open,
		photo,
		profileLink,
		streamTitle,
		theatreModeToggle,
		anchorEl,
		handleFollowGAEvent
	} = props;

	const { classes } = useStyles ( { theatreModeToggle }, { name: "broadcastHeader" } );
	const { t }       = useTranslation ();

	const mainCtn = theatreModeToggle ? {
		display        : "flex",
		alignItems     : "center",
		justifyContent : "space-between"
	} : {};

	const deviceType = useGetDeviceType ();
	const isMobile   = deviceType === "mobile";

	return (
		<div className = { classes.headerContainer }>
			<div style = { mainCtn }>
				<div className = { classes.rootContainer }>
					<div className = { `flex alignItemsCenter ${ classes.creatorContainer }` }>
						<div className = { `${ !theatreModeToggle ? classes.avatar : classes.avatarTheatre } cursorPointer` }>
							<Link href = { profileLink }
								prefetch  = { false }
							>
								<Image className = { classes.img }
									src             = { photo }
								/>
							</Link>
						</div>

						<div>

							<Link href = { profileLink }
								prefetch  = { false }
							>
								<div className = { `${ classes.nameCtn } ${ classes.leftMargin }` }>

									<div className = { classes.verifiedIconContainer }>
										<Typography
											className = { !theatreModeToggle ? classes.broadcasterName : "fontBold colorWhite" }
											title     = { name }
										/>

										{isCeleb ? (
											<div className = { classes.verifiedUsers }>
												<Icon
													sameInBothTheme
													className = { classes.svgIcon }
													name      = "verify"
												/>
											</div>
										) : null}
									</div>

									<Typography
										className = { !theatreModeToggle ? classes.streamerFollowersStyleDark : classes.streamerFollowersTheatre }
										color     = "secondary"
										title     = { `${ shortenNumber ( noOfFollowers ) || "" } Followers` }
									/>
								</div>
							</Link>
						</div>
					</div>

					<div className = { classes.leftMargin }>
						{
							isBlockedByStreamer ? (
								followProfile ? (
									<PrimaryButton
										active
										size  = "small"
										title = { t ( "profile_unfollow" ) }
									/>

								) : (
									<PrimaryButton
										buttonTextClassName = { classes.followBtn }
										onClick             = { () => { } }
										size                = "small"
										title               = { followProfile ? t ( "profile_unfollow" ) : `+ ${ t ( "profile_follow" ) }` }
									/>
								)
							) : (
								<FollowUser
									followComponent   = { (
										<PrimaryButton
											buttonTextClassName = { classes.followBtn }
											size                = "small"
											title               = { `+ ${ t ( "profile_follow" ) }` }
										/>
									) }
									handleGAEvent     = { handleFollowGAEvent }
									isFollowing       = { followProfile }
									unfollowComponent = { (
										<SecondaryButton
											buttonTextClassName = { classes.unfollowButtonText }
											size                = "small"
											title               = { `+ ${ t ( "profile_unfollow" ) }` }
										/>
									) }
									userId            = { id }
									userName          = { name }
								/>
							)
						}
					</div>
				</div>

				{
					theatreModeToggle && (
						<div>
							<div
								className = { `${ classes.shareBtnContainer } rightSpacing` }
								onClick   = { e => handleClickOpen ( e ) }
							>

								<Icon className = { classes.svgShareIcon }
									name           = "share"
								/>

								<Typography
									className = { `${ classes.share } leftSpacing` }
									title     = { t ( "action_share" ) }
								/>

							</div>
						</div>
					)
				}
			</div>

			{
				theatreModeToggle && (
					<div className = "leftSpacing topSpacing bottomSpacing">
						{streamTitle}
					</div>
				)
			}

			{
				description && !theatreModeToggle && !isMobile && (
					<Description description = { description } />
				)
			}

			<SharePopper
				useModal
				anchorEl    = { anchorEl }
				getSrc      = { getSrc }
				handleClose = { handleClickAway }
				open        = { open }
				placement   = "left-start"
				title       = { streamTitle }
			/>
		</div>
	);
};

export default component;
